import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {Subscription} from "rxjs";
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UsuarioBasculaGaritaService} from '../../services/usuario-bascula-garita.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {IMantBascula} from '../../modelos/IMantBascula';
import {UsuariosService} from '../../services/usuarios.service';
import {IUsuarioAll} from '../../modelos/IUsuario.js';
import {MantenimientoUsuarioAprobadorService} from '../../services/mantenimiento-usuario-aprobador.service';

@Component({
  selector: 'app-usuarios-aprobadores',
  templateUrl: './usuarios-aprobadores.component.html',
  styleUrls: ['./usuarios-aprobadores.component.css']

})
export class UsuariosAprobadoresComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.usuariosAprobadores;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    nombre: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]), // TODO agregar pattern de email.
    telefono: new FormControl(null, []),
  });

  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private usuariosService: UsuariosService,
    private MantenimientoUsuarioAprobadorService: MantenimientoUsuarioAprobadorService
  ) {
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Usuario',
        field: 'nombre',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Email',
        field: 'email',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Teléfono',
        field: 'telefono',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      }
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.MantenimientoUsuarioAprobadorService.obtener().subscribe(
        (resp) => {
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        // text: `Usuario: ${data.idusuario} ${data.bascula?`- Báscula: ${data.bascula}`: ``} ${data.garita?`- Garita: ${data.garita}`: ``}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.MantenimientoUsuarioAprobadorService.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        // text: `Usuario: ${data.idusuario} ${data.bascula?`- Báscula: ${data.bascula}`: ``} ${data.garita?`- Garita: ${data.garita}`: ``}`,
        action: this.DAT_BTNS.editar,
        funcion: this.MantenimientoUsuarioAprobadorService.editar(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  // TODO REVISAR NO ELIMINA
  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `Usuario: ${rowData.idusuario} ${rowData.bascula?`- Báscula: ${rowData.bascula}`: ``} ${rowData.garita?`- Garita: ${rowData.garita}`: ``}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.MantenimientoUsuarioAprobadorService.eliminar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.get('id').disable();
    this.openModal();
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get('id').disable();
    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
